import React from 'react';
import { DialogTitle as MuiDialogTitle } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { secondary1000 } from '../../../src/themes/colors';

const styles = theme => ({
  DialogTitleRoot: {
    color: secondary1000,
    fontFamily: theme.typography.fontFamily,
    fontSize: '1rem !important',
    fontWeight: '600 !important',
    letterSpacing: '-0.013rem',
    padding: 0,
    textAlign: 'center',
    marginBottom: '1.5rem',
  },
});

const DialogTitle = (props) => {
  const { classes } = props;
  return (
    <MuiDialogTitle
      {...props}
      classes={{ root: classes.DialogTitleRoot }}
    >
      {props.children}
    </MuiDialogTitle>
  );
};

export default withStyles(styles)(DialogTitle);
